import { AxiosService } from './axios.service'
import { SearchService } from './search.service'
import {
	paginationErrorHandler,
	paginationSuccessHandler
} from './pagination-handlers'

/**
 * Defines the API methods for client reports
 */
export class ClientReportsService extends SearchService {
	static baseURL = 'cliente/relatorios'

	/**
	 * Searches the client's purchases
	 */
	static searchPurchases(params) {
		return AxiosService.get(
			`${ClientReportsService.baseURL}/pesquisar-minhas-compras`,
			{
				params
			}
		)
			.then(paginationSuccessHandler)
			.catch(paginationErrorHandler)
	}

	/**
	 * Gets client's pay history
	 */
	static getPayHistory(params) {
		return AxiosService.get(
			`${ClientReportsService.baseURL}/historico-de-pagamentos`,
			{
				params
			}
		)
			.then(paginationSuccessHandler)
			.catch(paginationErrorHandler)
	}
}
